import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import SmoothScroll from "@/components/SmoothScroll";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Gallery from "@/pages/Gallery";
import Subscription from "@/pages/Subscription";
import Things from "@/pages/Things";
import { BlogList, BlogPost } from "@/pages/Blog";
import Contact from "@/pages/Contact";
import CommercialEnquiries from "@/pages/CommercialEnquiries";
import { Login, Register } from "@/pages/Auth";
import Dashboard from "@/pages/Dashboard";
import MapPage from "@/pages/MapPage";
import Admin from "@/pages/Admin";
import CommunitySpotlight from "@/pages/CommunitySpotlight";
import StartHere from "@/pages/StartHere";
import PilotLog from "@/pages/PilotLog";
import Book from "@/pages/Book";
import Safety from "@/pages/Safety";
import Portfolio from "@/pages/Portfolio";
import Terms from "@/pages/Terms";
import NC500Wishlist from "@/pages/NC500Wishlist";

export default function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <AuthProvider>
                    <SmoothScroll>
                        <Routes>
                            <Route element={<Layout />}>
                                <Route path="/" element={<Home />} />
                                <Route path="/start-here" element={<StartHere />} />
                                <Route path="/pilots-log" element={<PilotLog />} />
                                <Route path="/book" element={<Book />} />
                                <Route path="/safety" element={<Safety />} />
                                <Route path="/about" element={<About />} />
                                <Route path="/gallery" element={<Gallery />} />
                                <Route path="/portfolio" element={<Portfolio />} />
                                <Route path="/terms" element={<Terms />} />
                                <Route path="/nc500" element={<NC500Wishlist />} />
                                <Route path="/map" element={<MapPage />} />
                                <Route path="/subscription" element={<Subscription />} />
                                <Route path="/things" element={<Things />} />
                                <Route path="/blog" element={<BlogList />} />
                                <Route path="/blog/:slug" element={<BlogPost />} />
                                <Route path="/contact" element={<Contact />} />
                                <Route path="/commercial-enquiries" element={<CommercialEnquiries />} />
                                <Route path="/login" element={<Login />} />
                                <Route path="/register" element={<Register />} />
                                <Route path="/dashboard" element={<Dashboard />} />
                                <Route path="/admin" element={<Admin />} />
                                <Route path="/spotlight" element={<CommunitySpotlight />} />
                            </Route>
                        </Routes>
                    </SmoothScroll>
                </AuthProvider>
            </BrowserRouter>
        </div>
    );
}
